export default __webpack_public_path__ + "static/media/colorWhatIfAbo.9af6402c.svg";